export default "__VITE_ASSET__Dht96s$k__"